"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertArticle = exports.replaceForwardSlashAll = exports.capitalize = void 0;
const WORD_ARTICLE_REGEX = /^([aeiou])/i;
const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
exports.capitalize = capitalize;
const replaceForwardSlashAll = (str) => str.replace("/", "\\");
exports.replaceForwardSlashAll = replaceForwardSlashAll;
const insertArticle = (word) => {
    const article = WORD_ARTICLE_REGEX.test(word) ? "an" : "a";
    return article + " " + word;
};
exports.insertArticle = insertArticle;
